import React from 'react';
import { Row, Col, Button, Table, SplitButton, MenuItem } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl, FormattedDate, FormattedNumber } from 'react-intl';
import moment from 'moment';
import 'moment-timezone';
import {
  isEmpty as _isEmpty,
  isEqual as _isEqual,
  round as _round,
  divide as _divide,
  isFinite as _isFinite,
  orderBy as _orderBy,
  get as _get,
} from 'lodash';

import { addNotification } from 'actions/NotificationsActions';
import { formStatusDispatchHelper, formReset } from 'actions/FormStatusActions';

import VklBusinessEquipments from 'components/layout/vkl/VklBusinessEquipments';
import VklBusinessWinleas from 'components/layout/vkl/VklBusinessWinleas';
import LeadInfos from 'components/layout/lead/LeadInfos';

import FormTextarea from 'components/forms/FormTextarea';

import LeadNew from 'components/modals/LeadNew';
import LeadAssign from 'components/modals/LeadAssign';

class VklBusinessData extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      commentInput: '',
      showCreateLead: false,
      showAssignLead: false,
    };
  }

  showCreateLead = () => {
    this.setState({ showCreateLead: true });
  };

  closeCreateLead = () => {
    this.setState({ showCreateLead: false });
  };

  showAssignLead = () => {
    this.setState({ showAssignLead: true });
  };

  closeAssignLead = () => {
    this.setState({ showAssignLead: false });
  };

  submitStatus = status => {
    const { data, onSubmit, onActivityChanged } = this.props;

    const submitData = { ...data, status };

    onSubmit(data.id, submitData);

    if (onActivityChanged) {
      onActivityChanged(submitData);
    }
  };

  addComment = content => {
    const { data, onSubmit, onActivityChanged } = this.props;

    const submitData = { ...data };
    submitData.comments = submitData.comments.slice();
    submitData.comments.push({ content });

    onSubmit(data.id, submitData);

    if (onActivityChanged) {
      onActivityChanged(submitData);
    }
  };

  getDiscount = activity => {
    const { projectConfig } = this.props;

    if (activity.sales_price && activity.list_price && activity.sales_price !== activity.list_price) {
      const perc = 1 - _round(_divide(activity.sales_price, activity.list_price), 2);
      if (_isFinite(perc)) {
        return (
          <span>
            <FormattedNumber
              value={activity.list_price - activity.sales_price}
              style="currency"
              currency={projectConfig.data.currency}
            />{' '}
            (<FormattedNumber value={perc} style="percent" />)
          </span>
        );
      }
    }

    return '-';
  };

  getCustomerCompany = activity => {
    const {
      intl: { messages },
    } = this.props;

    return (
      <div class="panel panel-transparent">
        <div class="panel-body no-padding">
          <h4>{messages.client}</h4>
          <div>
            <Table responsive hover condensed>
              <tbody>
                <tr>
                  <td>{messages.company}</td>
                  <td>{activity.customer_company_name || '-'}</td>
                </tr>
                <tr>
                  <td>{messages.sad.customer_account_number}</td>
                  <td>{activity.customer_account_number || '-'}</td>
                </tr>
                <tr>
                  <td>{messages.address}</td>
                  <td>
                    {activity.customer_street} {activity.customer_street_number}
                    <br />
                    {activity.customer_zip_code} {activity.customer_city}
                    <br />
                    {activity.customer_country}
                  </td>
                </tr>
                <tr>
                  <td>{messages.sad.contact_person}</td>
                  <td>
                    {_isEmpty(activity.customer_salutation) ? '' : `${activity.customer_salutation} `}
                    {_isEmpty(activity.customer_title) ? '' : `${activity.customer_title} `}
                    {_isEmpty(activity.customer_firstname) ? '' : `${activity.customer_firstname} `}
                    {_isEmpty(activity.customer_lastname) ? '' : `${activity.customer_lastname} `}
                  </td>
                </tr>
                <tr>
                  <td>{messages.email}</td>
                  <td>
                    {_isEmpty(activity.customer_mail) ? (
                      '-'
                    ) : (
                      <a href={`mailto:${activity.customer_mail}`}>{activity.customer_mail}</a>
                    )}
                  </td>
                </tr>
                <tr>
                  <td>{messages.phone}</td>
                  <td>
                    {activity.customer_phone_mobile ||
                      activity.customer_phone_business ||
                      activity.customer_phone_private ||
                      '-'}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  };

  getCustomerPrivate = activity => {
    const {
      intl: { messages },
    } = this.props;

    return (
      <div class="panel panel-transparent">
        <div class="panel-body no-padding">
          <h4>{messages.client}</h4>
          <div>
            <Table responsive hover condensed>
              <tbody>
                <tr>
                  <td>{messages.name}</td>
                  <td>
                    {_isEmpty(activity.customer_salutation) ? '' : `${activity.customer_salutation} `}
                    {_isEmpty(activity.customer_title) ? '' : `${activity.customer_title} `}
                    {_isEmpty(activity.customer_firstname) ? '' : `${activity.customer_firstname} `}
                    {_isEmpty(activity.customer_lastname) ? '' : `${activity.customer_lastname} `}
                  </td>
                </tr>
                <tr>
                  <td>{messages.sad.customer_account_number}</td>
                  <td>{activity.customer_account_number || '-'}</td>
                </tr>
                <tr>
                  <td>{messages.address}</td>
                  <td>
                    {activity.customer_street} {activity.customer_street_number}
                    <br />
                    {activity.customer_zip_code} {activity.customer_city}
                    <br />
                    {activity.customer_country}
                  </td>
                </tr>
                <tr>
                  <td>{messages.email}</td>
                  <td>
                    {_isEmpty(activity.customer_mail) ? (
                      '-'
                    ) : (
                      <a href={`mailto:${activity.customer_mail}`}>{activity.customer_mail}</a>
                    )}
                  </td>
                </tr>
                <tr>
                  <td>{messages.phone}</td>
                  <td>
                    {activity.customer_phone_mobile ||
                      activity.customer_phone_business ||
                      activity.customer_phone_private ||
                      '-'}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  };

  getCustomer = activity => {
    if (activity.customer_type === 'company' || !_isEmpty(activity.customer_company_name)) {
      return this.getCustomerCompany(activity);
    }
    return this.getCustomerPrivate(activity);
  };

  getOnlineConfiguratorLink = onlineCode => {
    return `https://www.mercedes-benz.de/passengercars/content-pool/tool-pages/car-configurator.html/summary?Mcid=${onlineCode}`;
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      formStatus,
      doNotify,
    } = this.props;

    if (prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError) {
      this.setState({ commentInput: '' }, () => {
        doNotify(1, messages.changes_saved);
      });
    }
  };

  carData = data => {
    const {
      intl: { messages },
      projectConfig,
    } = this.props;

    return (
      <Table responsive hover condensed>
        <tbody>
          <tr>
            <td>{messages.sad.class}</td>
            <td>{_isEmpty(data.car_model_name) ? '-' : data.car_model_name}</td>
          </tr>
          <tr>
            <td>{messages.sad.model_name_short}</td>
            <td>{_isEmpty(data.sales_description_short) ? '-' : data.sales_description_short}</td>
          </tr>
          <tr>
            <td>{messages.sad.model_name}</td>
            <td>{_isEmpty(data.sales_description) ? '-' : data.sales_description}</td>
          </tr>
          <tr>
            <td>{messages.sad.model_range}</td>
            <td>{_isEmpty(data.car_model_id) ? '-' : data.car_model_id}</td>
          </tr>
          <tr>
            <td>{messages.sad.body_design}</td>
            <td>{_isEmpty(data.car_type_name) ? '-' : data.car_type_name}</td>
          </tr>
          <tr>
            <td>{messages.sad.car_color}</td>
            <td>{_isEmpty(data.car_color) ? '-' : data.car_color}</td>
          </tr>
          <tr>
            <td>{messages.sad.base_price}</td>
            <td>
              {data.car_base_price ? (
                <FormattedNumber value={data.car_base_price} style="currency" currency={projectConfig.data.currency} />
              ) : (
                '-'
              )}
            </td>
          </tr>
          <tr>
            <td>
              {messages.sad.list_price} {messages.sad.incl} {messages.sad.optional_equipment}
            </td>
            <td>
              {data.list_price ? (
                <FormattedNumber value={data.list_price} style="currency" currency={projectConfig.data.currency} />
              ) : (
                '-'
              )}
            </td>
          </tr>
          <tr>
            <td>{messages.sad.discount}</td>
            <td>{this.getDiscount(data)}</td>
          </tr>
          <tr>
            <td>{messages.sad.sales_price}</td>
            <td>
              {data.sales_price ? (
                <FormattedNumber value={data.sales_price} style="currency" currency={projectConfig.data.currency} />
              ) : (
                '-'
              )}
            </td>
          </tr>
        </tbody>
      </Table>
    );
  };

  carDataOtr = data => {
    const {
      intl: { messages },
      projectConfig,
    } = this.props;

    return (
      <Table responsive hover condensed>
        <tbody>
          <tr>
            <td>{messages.sad.class}</td>
            <td>{_isEmpty(data.car_model_name) ? '-' : data.car_model_name}</td>
          </tr>
          <tr>
            <td>{messages.sad.model_name}</td>
            <td>{_isEmpty(data.sales_description) ? '-' : data.sales_description}</td>
          </tr>
          <tr>
            <td>{messages.sad.car_image}</td>
            <td>
              {data.car_image_url ? (
                <a href={data.car_image_url} target="_blank">
                  <img src={data.car_image_url} height="50px" alt="" />
                </a>
              ) : (
                '-'
              )}
            </td>
          </tr>
          <tr>
            <td>{messages.sad.model_range}</td>
            <td>{_isEmpty(data.car_model_id) ? '-' : data.car_model_id}</td>
          </tr>
          <tr>
            <td>{messages.sad.body_design}</td>
            <td>{_isEmpty(data.car_type_name) ? '-' : data.car_type_name}</td>
          </tr>
          <tr>
            <td>{messages.sad.car_color}</td>
            <td>{_isEmpty(data.car_color) ? '-' : data.car_color}</td>
          </tr>
          <tr>
            <td>{messages.car_fueltype}</td>
            <td>{_isEmpty(data.car_fuel) ? '-' : data.car_fuel}</td>
          </tr>
          <tr>
            <td>{messages.car_gear}</td>
            <td>{_isEmpty(data.car_transmission_type) ? '-' : data.car_transmission_type}</td>
          </tr>
          <tr>
            <td>{messages.car_power}</td>
            <td>{_isEmpty(data.car_power) ? '-' : data.car_power}</td>
          </tr>
          <tr>
            <td>{messages.car_capacity}</td>
            <td>{_isEmpty(data.car_capacity) ? '-' : data.car_capacity}</td>
          </tr>
          <tr>
            <td>{messages.sad.max_speed}</td>
            <td>{_isEmpty(data.car_max_speed) ? '-' : data.car_max_speed}</td>
          </tr>
          <tr>
            <td>{messages.sad.car_acceleration}</td>
            <td>{_isEmpty(data.car_acceleration) ? '-' : data.car_acceleration}</td>
          </tr>
          <tr>
            <td>{messages.sad.online_code}</td>
            <td>{_isEmpty(data.online_code) ? '-' : data.online_code}</td>
          </tr>
          <tr>
            <td>{messages.sad.base_price}</td>
            <td>
              {data.car_base_price ? (
                <FormattedNumber value={data.car_base_price} style="currency" currency={projectConfig.data.currency} />
              ) : (
                '-'
              )}
            </td>
          </tr>
          <tr>
            <td>{messages.sad.price_reduction}</td>
            <td>
              {data.price_reduction_net ? (
                <FormattedNumber
                  value={data.price_reduction_net}
                  style="currency"
                  currency={projectConfig.data.currency}
                />
              ) : (
                '-'
              )}{' '}
              {data.price_reduction_code ? `(${data.price_reduction_code})` : ''}
            </td>
          </tr>
          <tr>
            <td>
              {messages.sad.list_price} {messages.sad.incl} {messages.sad.optional_equipment}
            </td>
            <td>
              {data.list_price ? (
                <FormattedNumber value={data.list_price} style="currency" currency={projectConfig.data.currency} />
              ) : (
                '-'
              )}
            </td>
          </tr>
          <tr>
            <td>{messages.sad.cash_discount}</td>
            <td>
              {data.cash_discount ? (
                <FormattedNumber value={data.cash_discount} style="currency" currency={projectConfig.data.currency} />
              ) : (
                '-'
              )}
            </td>
          </tr>
          <tr>
            <td>{messages.sad.volume_discount}</td>
            <td>
              {data.volume_discount ? (
                <FormattedNumber value={data.volume_discount} style="currency" currency={projectConfig.data.currency} />
              ) : (
                '-'
              )}
            </td>
          </tr>
          <tr>
            <td>{messages.sad.discount_additional}</td>
            <td>
              {data.additional_conditions ? (
                <FormattedNumber
                  value={data.additional_conditions}
                  style="currency"
                  currency={projectConfig.data.currency}
                />
              ) : (
                '-'
              )}
            </td>
          </tr>
          <tr>
            <td>{messages.sad.discount_environmental}</td>
            <td>
              {data.eco_discount ? (
                <FormattedNumber value={data.eco_discount} style="currency" currency={projectConfig.data.currency} />
              ) : (
                '-'
              )}
            </td>
          </tr>
          <tr>
            <td>{messages.sad.discount}</td>
            <td>{this.getDiscount(data)}</td>
          </tr>
          <tr>
            <td>{messages.sad.sales_price}</td>
            <td>
              {data.sales_price ? (
                <FormattedNumber value={data.sales_price} style="currency" currency={projectConfig.data.currency} />
              ) : (
                '-'
              )}
            </td>
          </tr>
          <tr>
            <td>{messages.sad.transportation_costs}</td>
            <td>
              {data.transportation_costs ? (
                <FormattedNumber
                  value={data.transportation_costs}
                  style="currency"
                  currency={projectConfig.data.currency}
                />
              ) : (
                '-'
              )}
            </td>
          </tr>
        </tbody>
      </Table>
    );
  };

  render() {
    const {
      intl: { messages },
      user,
      data,
      colSpan,
    } = this.props;

    return (
      <tr class="row-details">
        <td colSpan={colSpan}>
          <Row class="p-l-5 p-r-5 text-right">
            {data.status === '100' || data.status === '700' ? (
              <Button
                class="m-r-10"
                bsSize="sm"
                type="submit"
                bsStyle="default"
                onClick={() => {
                  this.submitStatus('500');
                }}
              >
                <i class="fa-fw fas fa-copy" /> {messages.sad.predecessor_offer}
              </Button>
            ) : null}
            {data.status === '100' || data.status === '500' ? (
              <Button
                class="m-r-10"
                bsSize="sm"
                type="submit"
                bsStyle="danger"
                onClick={() => {
                  this.submitStatus('700');
                }}
              >
                <i class="fa-fw fas fa-times" /> {messages.sad.lost}
              </Button>
            ) : null}
            {data.status === '900' && (
              <Button
                class="m-r-10"
                bsSize="sm"
                type="submit"
                bsStyle="danger"
                onClick={() => {
                  this.submitStatus('950');
                }}
              >
                <i class="fa-fw fas fa-ban" /> {messages.sad.canceled}
              </Button>
            )}
            {data.status === '950' && (
              <Button
                class="m-r-10"
                bsSize="sm"
                type="submit"
                bsStyle="success"
                onClick={() => {
                  this.submitStatus('900');
                }}
              >
                <i class="fa-fw fas fa-check" /> {messages.sad.ordered}
              </Button>
            )}
          </Row>
          <hr />
          <Row>
            <Col xs={12} md={12} lg={4}>
              <div class="panel panel-transparent">
                <div class="panel-body no-padding">
                  <div class="clearfix">
                    <h4 style={{ float: 'left' }}>{messages.sad.car_data}</h4>
                    <h4 style={{ float: 'right' }}>
                      {_isEmpty(data.online_code) ? (
                        ''
                      ) : (
                        <a href={this.getOnlineConfiguratorLink(data.online_code)} target="_blank">
                          Konfigurator <i class="fas fa-external-link-alt" />
                        </a>
                      )}
                    </h4>
                  </div>
                  <div>{data.source === 'OTR' ? this.carDataOtr(data) : this.carData(data)}</div>
                </div>
              </div>
            </Col>
            <Col xs={12} md={12} lg={8}>
              <Row>
                <Col xs={12} md={12} lg={6}>
                  <div class="panel panel-transparent">
                    <div class="panel-body no-padding">
                      <h4>{messages.sad.sales_activity}</h4>
                      <div>
                        <Table responsive hover condensed>
                          <tbody>
                            <tr>
                              <td>{messages.name}</td>
                              <td>{_isEmpty(data.name) ? '-' : data.name}</td>
                            </tr>
                            <tr>
                              <td>{messages.sad.offer_date}</td>
                              <td>
                                {_isEmpty(data.reference_date) ? (
                                  '-'
                                ) : (
                                  <FormattedDate
                                    value={new Date(moment.tz(data.reference_date, 'UTC').tz(user.profile.timezone))}
                                  />
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td>{messages.sad.last_modified}</td>
                              <td>
                                {_isEmpty(data.last_modified_date) ? (
                                  '-'
                                ) : (
                                  <FormattedDate
                                    value={
                                      new Date(moment.tz(data.last_modified_date, 'UTC').tz(user.profile.timezone))
                                    }
                                  />
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td>{messages.sad.order_date}</td>
                              <td>
                                {_isEmpty(data.order_date) ? (
                                  '-'
                                ) : (
                                  <FormattedDate
                                    value={new Date(moment.tz(data.order_date, 'UTC').tz(user.profile.timezone))}
                                  />
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td>{messages.sad.order_location}</td>
                              <td>{_isEmpty(data.order_location) ? '-' : data.order_location}</td>
                            </tr>
                            <tr>
                              <td>{messages.sad.pre_contract_nr}</td>
                              <td>{_isEmpty(data.pre_contract_number) ? '-' : data.pre_contract_number}</td>
                            </tr>
                            <tr>
                              <td>{messages.sad.pre_contract_date}</td>
                              <td>
                                {_isEmpty(data.last_pre_contract_date) ? (
                                  '-'
                                ) : (
                                  <FormattedDate
                                    value={
                                      new Date(moment.tz(data.last_pre_contract_date, 'UTC').tz(user.profile.timezone))
                                    }
                                  />
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td>{messages.sad.contract_nr}</td>
                              <td>{_isEmpty(data.contract_number) ? '-' : data.contract_number}</td>
                            </tr>
                            <tr>
                              <td>{messages.sad.special_agreement}</td>
                              <td>{data.special_agreement ? data.special_agreement : '-'}</td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>
                  <div class="panel panel-transparent">
                    <div class="panel-body no-padding">
                      <h4>{messages.sad.salesman}</h4>
                      <div>
                        <Table responsive hover condensed>
                          <tbody>
                            <tr>
                              <td>{messages.name}</td>
                              <td>
                                {data.salesman_firstname} {data.salesman_lastname}
                              </td>
                            </tr>
                            <tr>
                              <td>{messages.sad.salesman_number}</td>
                              <td>{data.salesman_number}</td>
                            </tr>
                            <tr>
                              <td>{messages.sad.enterprise_number}</td>
                              <td>{_isEmpty(data.salesman_company_number) ? '-' : data.salesman_company_number}</td>
                            </tr>
                            <tr>
                              <td>{messages.company}</td>
                              <td>
                                <div>{data.salesman_company_name}</div>
                                <div>
                                  {_isEqual(data.salesman_company_name, data.salesman_company_name_addition1)
                                    ? null
                                    : data.salesman_company_name_addition1}
                                </div>
                                <div>{data.salesman_company_name_addition2}</div>
                                <div>
                                  {data.salesman_company_street}, {data.salesman_company_zip_code}{' '}
                                  {data.salesman_company_city}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={12} lg={6}>
                  {this.getCustomer(data)}
                  <div class="panel panel-transparent">
                    <div class="panel-body no-padding">
                      <h4>{messages.sad.notes}</h4>
                      <div>
                        <div class="panel panel-transparent">
                          <div class="panel-body">
                            <div class="form-group-attached">
                              <FormTextarea
                                label={null}
                                name="commentInput"
                                onChange={(name, value) => this.setState({ [name]: value })}
                                disabled={this.props.formStatus.pending}
                              />
                            </div>

                            <div class="text-right m-t-10">
                              <Button
                                disabled={this.state.commentInput.length === 0 || this.props.formStatus.pending}
                                type="submit"
                                bsStyle="primary"
                                onClick={() => {
                                  this.addComment(this.state.commentInput);
                                }}
                              >
                                <i
                                  class={
                                    'fa-fw ' +
                                    (this.props.formStatus.pending ? ' fa fa-circle-notch fa-spin' : 'fas fa-save')
                                  }
                                />{' '}
                                {messages.sad.note_save}
                              </Button>
                            </div>
                          </div>
                        </div>

                        <Table responsive hover condensed>
                          <tbody>
                            {_orderBy(data.comments, 'cdate', 'desc').map((comment, i) => {
                              return (
                                <tr key={i}>
                                  <td style={{ width: '90px' }}>
                                    <FormattedDate
                                      value={
                                        new Date(moment.tz(_get(comment, 'cdate'), 'UTC').tz(user.profile.timezone))
                                      }
                                    />
                                  </td>
                                  <td style={{ width: '120px' }}>{_get(comment, 'creator.name')}</td>
                                  <td>{_get(comment, 'content')}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>
                  <div class="panel panel-transparent">
                    <div class="panel-body no-padding">
                      <h4>{messages.lead}</h4>
                      {data.lead ? (
                        <div class="card card-default bg-master-lighter padding-20 sm-padding-10">
                          <LeadInfos lead={data.lead} addEditAction />
                        </div>
                      ) : (
                        <div>
                          <SplitButton onClick={this.showCreateLead} title={messages.create_lead} id="lead-actions">
                            <MenuItem eventKey="1" onClick={this.showAssignLead}>
                              {messages.assign_lead}
                            </MenuItem>
                          </SplitButton>
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={8}>
              <VklBusinessWinleas winleases={data.winleases} />
            </Col>
            <Col xs={12} lg={4}>
              <VklBusinessEquipments equipments={data.equipments} />
            </Col>
          </Row>

          <LeadNew
            show={this.state.showCreateLead}
            close={this.closeCreateLead}
            onSubmitParent={lead => this.props.onSubmit(data.id, { lead })}
          />
          <LeadAssign
            show={this.state.showAssignLead}
            close={this.closeAssignLead}
            onSelect={lead => this.props.onSubmit(data.id, { lead })}
          />
        </td>
      </tr>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSubmit: (activityId, args) => {
      formStatusDispatchHelper(
        'salesActivityEdit',
        '/api/plugin/salesActivityDashboard/activities/' + activityId + '.json',
        args,
        'put',
        dispatch
      );
    },
    onFormSuccessfull: () => {
      dispatch(formReset('salesActivityEdit'));
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};
const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    projectConfig: state.data.projectConfig,
    user: state.login.user,
    formStatus: state.formStatus.salesActivityEdit,
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(VklBusinessData)
  )
);
